export default {
  home: 'Hello',
  switchLang: '日本語',
};
